<template>
    <div>
        <div v-show="!showTableDraggable">
            <ItemsSupplierOrderCreate :supplierOrder="supplierOrder" />
            <br />
            <Loading type="line" :center="false" v-show="loading" />
            <b-row>
                <b-col sm="6">
                    <b-form-checkbox v-model="showSelectAll" @change="select" v-show="content.totalRecords > 0">
                        TODOS PRODUTOS
                    </b-form-checkbox>
                </b-col>
                <b-col sm="6">
                    <TableTotalRecords :totalRecords="content.totalRecords" />
                </b-col>
            </b-row>
        </div>
        <ItemsSupplierOrderFixedBar :selected="selected" />
        <div v-if="!showTableDraggable">
            <table class="table table-responsive-xs">
                <thead>
                    <tr>
                        <th>
                            <i v-if="content.data.length > 1" class="fa-regular fa-maximize icon-order icon-cursor"
                                @click="changeItemToTableDraggable(content.data)">
                            </i>
                        </th>
                        <th>
                            <span class="title-header"> Produto </span>
                        </th>
                        <th class="text-center">
                            <span class="title-header">Quantidade</span>
                        </th>
                        <th class="text-center">
                            <span class="title-header">Valor</span>
                        </th>
                    </tr>
                </thead>
                <tbody v-for="item in content.data" :key="item.id">
                    <td class="td-checkbox">
                        <b-form-checkbox v-model="selected" :value="item.id" />
                    </td>
                    <td class="td-product td" @click="update(item)">
                        <span>
                            {{ item.productFullName }}
                        </span>
                        <br />
                        <span class="description" v-html="item.description"> </span>
                    </td>
                    <td class="text-center td-quantity td">
                        <div>
                            <span> {{ item.quantity }}</span>
                        </div>
                    </td>
                    <td class="text-center td-value td">
                        <div>
                            <span class="unit value"><small>Unit</small> {{ item.unitValue | currency }}</span> |
                            <span class="total value"><small>Tot..</small> {{ item.totalUnitValue |
                                currency }}</span>
                        </div>
                    </td>
                </tbody>
                <tbody v-show="content.totalRecords == 0">
                    <tr>
                        <td colspan="12">
                            <span class="title">Nenhum registro encontrado!</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <TableDraggable urlOrderAllApi="/api/v1/supplier/items-supplier-order/order-all" v-else :data="dataDraggable" />
        <Modal title="Produto" :width="800" v-if="showModal('item')">
            <ItemsSupplierOrderUpdate />
        </Modal>
    </div>
</template>
<script>


import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";
import TableTotalRecords from "@nixweb/nixloc-ui/src/component/shared/TableTotalRecords.vue";
import TableDraggable from "@nixweb/nixloc-ui/src/component/shared/TableDraggable.vue";
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";

import ItemsSupplierOrderFixedBar from './ItemsSupplierOrderFixedBar.vue'
import ItemsSupplierOrderCreate from './ItemsSupplierOrderCreate.vue'
import ItemsSupplierOrderUpdate from './ItemsSupplierOrderUpdate.vue'

import { mapGetters, mapState, mapActions, mapMutations } from "vuex";

export default {
    name: "ItemsSupplierOrder",
    props: ["supplierOrder"],
    components: {
        Loading, TableTotalRecords, TableDraggable, Modal, ItemsSupplierOrderCreate, ItemsSupplierOrderFixedBar, ItemsSupplierOrderUpdate
    },
    data() {
        return {
            urlGet: "/api/v1/supplier/items-supplier-order/get-all",
            urlDelete: "/api/v1/supplier/items-supplier-order/delete",
            content: {
                data: [],
                totalRecords: 0,
            },
            loading: false,
            showTableDraggable: false,
            dataDraggable: [],
            selected: [],
            showSelectAll: false,
        }
    },
    computed: {
        ...mapGetters("generic", ["event", "showModal"]),
    },
    methods: {
        ...mapMutations("generic", ["openModal", "addEvent", "removeLoading"]),
        ...mapActions("generic", ["getApi", "deleteAllApi"]),
        getAll() {
            this.loading = true;
            let params = {
                url: this.urlGet,
                obj: {
                    any: this.supplierOrder.id,
                },
            };
            this.getApi(params).then((response) => {
                this.content.data = response.content.data;
                this.content.totalRecords = response.content.totalRecords;
                this.loading = false;
            });
        },
        removeSelected() {
            let params = {
                url: this.urlDelete,
                selected: this.selected,
            };
            this.deleteAllApi(params).then((reponse) => {
                if (reponse.success) {
                    this.removeLoading(["btnRemoveItem"]);
                    this.selected = [];
                    this.addEvent({ name: "updateProduct" });
                    this.getAll();
                }
            });
        },
        select() {
            this.selected = [];
            if (this.showSelectAll) {
                for (let i in this.content.data) {
                    this.selected.push(this.content.data[i].id);
                }
            }
        },
        update(item) {
            this.openModal("item");
            this.addEvent({ name: "itemSupplierOrderUpdate", data: item });
        },
        changeItemToTableDraggable(data) {
            this.dataDraggable = [];
            this.showTableDraggable = true;
            data.forEach((item) => {
                let obj = { id: item.id, name: item.productFullName };
                this.dataDraggable.push(obj);
            });
        },
    },
    watch: {
        'supplierOrder.id': {
            handler() {
                this.getAll();
            },
            deep: true,
        },
        event: {
            handler(event) {
                if (event.name == "addedProduct" || event.name == "updateProduct") {
                    this.getAll();
                }

                if (event.name == "removeItemFixedBar") {
                    this.removeSelected();
                }

                if (event.name == "confirmedTableDraggable") {
                    this.showTableDraggable = false;
                    this.getAll();
                }

                if (event.name == "cancelTableDraggable")
                    this.showTableDraggable = false;
            },
            deep: true,
        },
    },
}
</script>
<style scoped>
.table th,
.table td {
    height: 10px !important;
    padding-left: 5px !important;
    padding-top: 7px !important;
    padding-bottom: 5px !important;
    padding-right: 5px !important;
    padding-left: 10px !important;
    border-bottom: 0px !important;
}

.title-header {
    font-size: 14px;
    color: #757d8c;
    font-weight: 400;
    text-transform: uppercase;
}

.td-checkbox {
    width: 30px;
}

.td-product {
    background-color: #f1f4f9;
    cursor: pointer;
}

.td-quantity {
    width: 150px;
}

.td-value {
    width: 300px;
}

.description {
    font-weight: 400;
    color: grey;
}

.unit {
    font-size: 13px;
}

.total {
    font-weight: 600;
    font-size: 15px;
}

.icon-cursor {
    cursor: pointer;
}
</style>
